(ns ycweb.components.slats
  (:require
   [rum.core :as rum]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.forms :as forms]
   [ycweb.util.core :as u]
   [util.string :as str]
   [inflections.core :as in]
   [ycweb.components.buttons :as buttons]))


(rum/defc order-slat < rum/reactive [type order-ref order-date customer-name item-count order-total {:keys [on-click]}]
  [:article.slat-wrapper
   [:a.slat.return-order-slat.u-block-link
    {:on-click (when on-click on-click)}
    [:div
     {:class (u/bem :flex-grid-group [:flush :align-left])}
     [:div
      {:class (u/bem :flex-grid-block [:1-2 :flush])}
      [:div.flex-grid-content
       [:h1.return-order-slat__order-no
        [:span.return-order-slat__label "Order Number: "]
        order-ref]
       ;;TODO - format date - will it always come through as mysql unixtime?
       [:p.return-order-slat__details "Placed: " order-date]]]
     [:div
      {:class (u/bem :flex-grid-block [:1-2 :flush :align-right])}
      [:div.flex-grid-content
       [:p.return-order-slat__customer
        [:span.return-order-slat__label
         (cond
           (= :shipped type) "Shipped to: "
           (= :collected type) "Collected by: "
           (= :shop type) "Bought at: "
           :else "Shipped to: ")]
        customer-name]
       [:p.return-order-slat__details item-count " Items | R" (u/number-format order-total 2 "." ",")]]]]]])

(rum/defc item-summary-slat < rum/reactive {:key-fn (fn [{:keys [id]}] (str id))}
  [{:keys [qty title feature]}]
  [:article.slat.product-slat
   [:div.product-slat__qty
    [:span qty]]
   [:div.product-slat__info
    [:header.product-slat__header
     [:div.product-slat__title-wrapper
      [:h1 {:class (u/bem :product-slat__title [:small])}
       [:b title]
       " " feature]]]]])

(rum/defc function-slat < rum/reactive {:key-fn (fn [{:keys [label]}] (str "key-" label))}
  [{:keys [label total on-click alert?]}]
  [:article.slat-wrapper
   [:a
    {:href "#", :on-click  on-click
     :class [:slat :action-button-slat :action-button-slat--large]}
    (when alert?
      [:div.slat__alert])
    [:div.action-button-slat__title label]
    (when total
      [:div.action-button-slat__status
       [:span {:class (u/bem :pill [:black])} total]])
    [:div.action-button-slat__icon-wrapper
     [:i {:class (u/bem :icon [:arrow-right :block])}]]]])

(rum/defc phantom-pick-slat < rum/reactive {:key-fn (fn [{:keys [location_id]}] (str location_id))}
  [{:keys [location icount readycount queuedcount on-click difficulty]}]
  [:article.slat.slat-wrapper.phantom-pick-slat
   {:on-click (when on-click on-click)}
   [:header.phantom-pick-slat__header
    [:h3.phantom-pick-slat__title
     location]
    (cond
      (= difficulty 1)
      [:span.u-text-sentencecase {:class (u/bem :pill [:medium :success])}
       [:b "Easy"]]

      (= difficulty 2)
      [:span.u-text-sentencecase {:class (u/bem :pill [:medium :warning])}
       [:b "Medium"]]

      (= difficulty 3)
      [:span.u-text-sentencecase {:class (u/bem :pill [:medium :error])}
       [:b "Hard"]])]
   [:ul.phantom-pick-slat__list
    (when icount
      [:li.phantom-pick-slat__list-item
       "Weber:"
       [:span.phantom-pick-slat__counter
        icount]])
    (when readycount
      [:li.phantom-pick-slat__list-item
       "Ready:"
       [:span.phantom-pick-slat__counter
        readycount]])
    (when queuedcount
      [:li.phantom-pick-slat__list-item
       "Pending:"
       [:span.phantom-pick-slat__counter
        queuedcount]])]])

(rum/defc location-slat < rum/static {:key-fn (fn [{:keys [location_id]}] (str location_id))}
  [{:keys [location icount readycount queuedcount on-click]}]
  [:article.slat.transfer-order-slat
   {:on-click (when on-click on-click)}
   [:header.transfer-order-slat__header
    [:div.transfer-order-slat__title-wrapper
     [:h1.transfer-order-slat__title
      [:span.transfer-order-slat__order-no location]
      [:span.transfer-order-slat__date
       (when icount (str "Weber:" icount))
       (when readycount (str " Ready:" readycount))
       (when queuedcount (str " Pending:" queuedcount))]]]]])

(rum/defc item-return-slat < rum/reactive
  [type {:keys [brand title features price existing serial-barcode needs-barcode?] :as item} & [{:keys [selected-atom change-fn selected-fn]}]]
  [:article.slat.product-slat
   {:class (when (and (= type :edit) (rum/react selected-atom)) ["slat--success"])}
   [:div.product-slat__info
    [:label.product-slat__checkbox-label
     [:header.product-slat__header

      [:div.product-slat__title-wrapper
       [:h1.product-slat__title
        [:span.product-slat__brand brand]
        title]
       (when existing
         (str "Existing Return case YCR" (:rid existing) " " (:rstatus existing) ", Item status: " (:istatus existing)))]
      (when (and (= type :edit) (not existing))
        [:div.product-slat__option
         [:div.product-slat__checkbox
          [:div.checkbox-label
           (forms/checkbox-raw selected-atom {:change-fn #(when @selected-atom (selected-fn))})
           [:span.checkbox__graphic-wrapper [:span.checkbox__graphic]]]]])]
     [:ul.product-slat__details
      (into
        [:li.product-slat__price
         [:span (when (and needs-barcode? (not serial-barcode)) "This product needs a serialized barcode") serial-barcode]
         [:span.product-slat__variation features]
         [:span "Unit: " [:b "R" (u/number-format price 2 "." ",")]]
         (when (:specialgroup/discount item)
           [:span "Discount: " [:b.u-text-status-discount "-R" (u/number-format (- (:specialgroup/discount item)) 2 "." ",")]])
         (when (:specialgroup/discount item)
           [:span "Total: " [:b "R" (u/number-format (+ price (:specialgroup/discount item)) 2 "." ",")]])])]]

    (when (= type :edit)
      (when (rum/react selected-atom)
        [:div.u-margin-top-16.u-text-right
         [:a
          {:href "#",
           :on-click (when selected-fn selected-fn)
           :class
           (u/bem
             :button
             [:has-icon-left :primary :small :text-default :flat])}
          [:span.button__text
           [:i.button__icon {:class (u/bem :icon [:2-2 :pencil :block])}]
           "Edit"]]]))]])


;;TODO - use this in more places - move to common? or util something?
(defn title-ex-brand [brand title]
  (str/trim (str/replace-first title brand "")))

(rum/defc item-stock-slat < rum/reactive
  [type {:keys [brand title feature stock-item-qty display_packsize packdescription]} & [{:keys [type options-fn]}]]
  (let [packsize
        (when (> (u/parseInt display_packsize) 1)
          (str packdescription " of " display_packsize))]
    [:article.slat.product-slat
     [:div.product-slat__qty
      (if (= :shrink type)
        [:span {:class "u-text-status-negative"} "-" stock-item-qty]
        [:span {:class "u-text-status-positive"} "+" stock-item-qty])]
     [:div.product-slat__info

      [:header.product-slat__header

       [:div.product-slat__title-wrapper
        [:h1.product-slat__title
         [:span.product-slat__brand brand]
         (title-ex-brand brand title)]]

       [:div.product-slat__option
        (buttons/button ""
          options-fn
          {:secondary true
           :icon-only :dots-menu
           :class :product-card__more-button})]]
      [:ul.product-slat__details
       [:li.product-slat__variation feature (when packsize [:span.u-text-status-important packsize])]]]]))

(rum/defc item-stock-summary-slat < rum/reactive
  [type {:keys [brand title feature stock-item-qty stock-item-reason display_packsize packdescription]} & [{:keys [type options-fn]}]]
  (let [packsize
        (when (> (u/parseInt display_packsize) 1)
          (str packdescription " of " display_packsize))]
    [:article.slat.product-slat
     [:div.product-slat__qty
      (if (= :shrink type)
        [:span {:class "u-text-status-negative"} "-" stock-item-qty]
        [:span {:class "u-text-status-positive"} "+" stock-item-qty])]
     [:div.product-slat__info
      [:header.product-slat__header
       [:div.product-slat__title-wrapper
        [:h1.product-slat__title.product-slat__title--small
         [:b brand] " " (title-ex-brand brand title) (when (u/presence feature) (str ", " feature)) (when packsize (str ", " packsize))]]]
      [:p.paragraph--flush.u-text-12.u-text-flush.u-text-status-important [:b "Reason: "] stock-item-reason]]]))

(rum/defc collection-order-slat < rum/reactive
  [{:keys [ref firstname lastname email boxes is-request? boxes-count]} {:keys [on-click]}]
  (let [locations (map (fn [b] [:span {:style {:white-space "nowrap"}} (:location b)]) boxes)
        locations-display (into [:span] (interpose ", " locations))
        multi? (> (count locations) 1)]
    [:article.slat.collect-order-slat
     [:div.u-margin-bottom-16
      {:class (u/bem :flex-grid-group [:align-left :flush])}
      [:div
       {:class (u/bem :flex-grid-block [:fluid :flush])}
       [:div.flex-grid-content
        (when ref
          [:h1.collect-order-slat__order-no
           [:span.collect-order-slat__label
            (if is-request? "Request Number: " "Order Number: ")] ref])]]
      [:div
       {:class (u/bem :flex-grid-block [:fluid :flush :align-right])}
       [:div.flex-grid-content
        [:div.u-text-right
         [:p.collect-order-slat__location
          [:span.collect-order-slat__label
           (if is-request?
             "No. of items"
             (in/pluralize (count locations) "Location")) ": "]
          (if is-request?
            [:span boxes-count]
            [:span (when multi? {:class "u-text-status-important"}) locations-display])]]]]]
     [:div.u-margin-bottom-8
      {:class (u/bem :flex-grid-group [:align-left :flush])}
      [:div
       {:class (u/bem :flex-grid-block [:fluid :flush])}
       [:div.flex-grid-content
        [:ul.collect-order-slat__details
         [:li.collect-order-slat__customer
          [:span.u-hidden-from-view "Order For: "]
          (str firstname " " lastname)]
         [:li.collect-order-slat__email
          [:span.u-hidden-from-view "Email Address: "]
          email]]]]
      [:div
       {:class (u/bem :flex-grid-block [:fluid :flush :align-right])}
       [:div.flex-grid-content
        [:div.u-text-right
         (buttons/button (if is-request? "Get Items" ["Collect" [:span.u-hidden-from-view " order"]])
           (when on-click on-click)
           {:primary true
            :small true
            :raised true})]]]]
     (when multi?
       [:div
        {:class (u/bem :flex-grid-group [:align-left :flush])}
        [:div.u-text-12.u-text-status-important
         {:class (u/bem :flex-grid-block [:full :flush])}
         [:div.flex-grid-content
          [:b "Note: "] "This order has multiple boxes in multiple locations."]]])]))

(rum/defcs slats-demo < (rum/local {} ::state) [s]
  (let [local-atom (::state s)]
    [:div.layout-component-demo
     (cmn/section "Basic Order Slats:")
     (order-slat :shipped 123456789 "27/06/2017" "Napolean Dynamite" 8 88888.88 {})
     (order-slat :collected 5122263 "02/09/2016" "John Smith" 3 12999 {})
     (order-slat :shop 2125536 "12/01/2012" "Jane Smith" 16 399.00 {})
     (item-return-slat :item {:type :edit :brand "Maxwell & Williams" :title "Maxwell & Williams Mulga Mug, 450ml" :price 99})
     (collection-order-slat {:ref "YC2125536" :firstname "Jane" :lastname "Smith"
                             :email "jane.smith@gmail.com" :boxes [{:location "E-3-B-1"} {:location "E-1-A-2"}]} {})
     (collection-order-slat {:ref "YC2125536" :firstname "Jane" :lastname "Smith"
                             :email "jane.smith@gmail.com" :boxes [{:location "E-1-A-2"}]} {})
     (grid/modal-background (rum/cursor local-atom :modal))
     (grid/modal (rum/cursor local-atom :modal) false)
     (grid/modal (rum/cursor local-atom :modal) true)]))
